/**
  * MISC CUSTOM SVG ICONS
  * When importing SVG asset files here
  * please prep the SVG file by removing
  * any styling form the <style> tag or inline
  * as it conflicts with our application CSS.
 */
export const ixSvgIcons = {
  anti_lock: 'assets/customicons/anti-lock.svg',
  dataset: 'assets/customicons/dataset.svg',
  freenas_certified: 'assets/customicons/logo_certified.svg',
  full_logo_rgb: 'assets/customicons/ix_full_logo_rgb.svg',
  full_logo: 'assets/customicons/ix_full_logo.svg',
  ha_disabled: 'assets/customicons/ha_disabled.svg',
  ha_enabled: 'assets/customicons/ha_enabled.svg',
  ha_reconnecting: 'assets/customicons/ha_reconnecting.svg',
  hdd_mirror: 'assets/customicons/ix-hdd-mirror.svg',
  hdd: 'assets/customicons/ix-hdd.svg',
  iscsi_share: 'assets/customicons/iscsi-share.svg',
  logomark_rgb: 'assets/customicons/ix_logomark_rgb.svg',
  logomark: 'assets/customicons/ix_logomark.svg',
  multipath: 'assets/customicons/multipath.svg',
  network_upload_download_disabled: 'assets/customicons/network-upload-download-disabled.svg',
  network_upload_download: 'assets/customicons/network-upload-download.svg',
  nfs_share: 'assets/customicons/nfs-share.svg',
  openzfs: 'assets/customicons/openzfs.svg',
  quota_fill: 'assets/customicons/quota-fill.svg',
  reservation_fill: 'assets/customicons/reservation-fill.svg',
  smb_share: 'assets/customicons/smb-share.svg',
  ssd_mirror: 'assets/customicons/ix-ssd-mirror.svg',
  ssd: 'assets/customicons/ix-ssd.svg',
  truecommand_logo_blue: 'assets/images/truecommand/truecommand-logo-mark-full-color-rgb.svg',
  truecommand_logo_white: 'assets/images/truecommand/truecommand-logo-mark-white-rgb.svg',
  truenas_scale_logo_full: 'assets/customicons/truenas_scale_logo_full.svg',
  truenas_scale_logomark_color: 'assets/customicons/truenas_scale_logomark_rgb.svg',
  truenas_scale_logomark: 'assets/customicons/truenas_scale_logomark.svg',
  truenas_scale_logotype_color: 'assets/customicons/truenas_scale_logotype_rgb.svg',
  truenas_scale_logotype: 'assets/customicons/truenas_scale_logotype.svg',
  webdav_share: 'assets/customicons/webdav-share.svg',
};
